import React from "react"
import Input from "../../../../Input/Input"
import { setTitle, setTitleInput } from "../../useReducer/actionCreators"

const TitleInput = ({ titleInput, externalDispatch }) => {
  return (
    <Input
      type="text"
      name="title"
      label="Title"
      placeholder="Enter title"
      fieldStyle="black"
      value={titleInput || ""}
      onChange={(e) => {
        externalDispatch(setTitleInput(e.target.value))
      }}
      onBlur={(e) => {
        if (e.target.value.trim()) {
          externalDispatch(setTitle(e.target.value.trim()))
        }
      }}
    />
  )
}
export default TitleInput
